export class WorkOrderUpdateWorkOrderStatusModel {
    public id: number;
    public workOrderStatus: number;
    public agreeCloseAllSubTaskAutomatically: boolean;
}
